/**
 * Dictionary tools.
 */
H_Tools.dictionary = (() => {
    // console.log('Dictionary tools initialized...');

    /**
     * Hides the supplied tooltip for the supplied dictionary entry.
     *
     * @param {*} entry   A dictionary entry element
     * @param {*} tooltip A tooltip element
     */
    function hideTooltip(entry, tooltip) {
        tooltip.hidePopover();
        entry.setAttribute('aria-expanded', 'false');
    }

    /**
     * Shows the supplied tooltip for the supplied dictionary entry.
     *
     * @param {*} entry   A dictionary entry element
     * @param {*} tooltip A tooltip element
     */
    function showTooltip(entry, tooltip) {
        tooltip.showPopover();
        entry.setAttribute('aria-expanded', 'true');
    }

    /**
     * Shows or hides the supplied tooltip for the supplied dictionary entry depending on its state.
     *
     * @param {*} entry   A dictionary entry element
     * @param {*} tooltip A tooltip element
     */
    function toggleTooltip(entry, tooltip) {
        // console.log('Toggling dictionary entry tooltip...');

        if (entry.getAttribute('aria-expanded') === 'true') {
            hideTooltip(entry, tooltip);
        } else {
            showTooltip(entry, tooltip);
        }
    }

    /**
     * Makes all dictionary entries inside the supplied elements reactive to mouse clicks and
     * keyboard interaction.
     *
     * This function may need to be reaplied if the DOM is manipulated using JavaScript.
     *
     * @param {*} elements One or more elements to process
     */
    function enableDictionaryEntries(...elements) {
        for (let element of elements) {
            element
                .querySelectorAll('.js-dictionary-entry')
                .forEach((entry) => {
                    /**
                     * Prevent adding the listener more than once by checking and setting an expando
                     * property on the element.
                     *
                     * @see https://developer.mozilla.org/en-US/docs/Glossary/Expando
                     */
                    if (entry.hasDictionaryListeners) {
                        return;
                    }
                    entry.hasDictionaryListeners = true;

                    const tooltip = entry.querySelector(
                        '#' + entry.getAttribute('aria-describedby')
                    );

                    if (!tooltip) {
                        return;
                    }

                    entry.setAttribute('aria-expanded', 'false');

                    entry.addEventListener('click', (e) => {
                        /**
                         * If the word is inside a link, this prevents the browser from following
                         * the link when the word is clicked to show the tooltip.
                         */
                        e.preventDefault();

                        toggleTooltip(entry, tooltip);
                    });
                    entry.addEventListener('blur', () =>
                        hideTooltip(entry, tooltip)
                    );
                    entry.addEventListener('keydown', (e) => {
                        if (H_Tools.key.isEnter(e)) {
                            e.stopPropagation();
                            toggleTooltip(entry, tooltip);
                        }
                        if (H_Tools.key.isEscape(e)) {
                            e.stopPropagation();
                            hideTooltip(entry, tooltip);
                        }
                        // if (H_Tools.key.isSpace(e)) {
                        //     e.preventDefault();
                        //     toggleTooltip(entry, tooltip);
                        // }
                    });
                });
        }
    }

    // return an object to expose inner functions
    return {
        enableDictionaryEntries: enableDictionaryEntries,
    };
})();
